module.exports = __webpack_public_path__ + "components/country-flag/static/td-1fcb1f097157b5e12c9058444e8b0db8.svg";